namespace GeniuzPOS.Product {
    export enum ProductFg {
        CreditLocal = 1,
        CreditImport = 2,
        ConsignInVat = 3,
        ConsignExVat = 4,
        Service = 5,
        Others = 6
    }
    Serenity.Decorators.registerEnumType(ProductFg, 'GeniuzPOS.Product.ProductFg');
}
